import { createAction, props } from '@ngrx/store';
import { IGqlFileEntitiesImport } from '../../interfaces/file-import.interfaces';
import {
	IAuPaginationData,
	IDjangoPaginationData,
} from '@app/shared/ui-components/au-paginator/pagination-page.info';
import {
	IQuickFilterCounters,
	IQuickFilterSelected,
} from '../../interfaces/quick-filter.interfaces';
import {
	ICmmsFilesFilterVariables,
	IFilesWithPaginationData,
} from '@app/pages/cmms/interfaces/files.interfaces';
import { ICMMSTableConfig } from '@app/pages/cmms/interfaces/cmms-table.interfaces';

export const setImportSessionInfo = createAction(
	'[IMPORTED FILES TABLE] Set Import Session Info',
	props<{ importSessionInfo: IGqlFileEntitiesImport }>()
);

export const loadImportSessionInfo = createAction(
	'[IMPORTED FILES TABLE] Load Import Session Info',
	props<{ sessionId: string }>()
);

export const setPaginationAndCounters = createAction(
	'[IMPORTED FILES TABLE] Set Pagination And Counters',
	props<{
		filesPagination: IDjangoPaginationData | null;
		fileImportCounters: IQuickFilterCounters | null;
	}>()
);

export const setPaginationData = createAction(
	'[IMPORTED FILES TABLE] Set Pagination',
	props<{ filesPagination: IDjangoPaginationData | null }>()
);

export const setCounters = createAction(
	'[IMPORTED FILES TABLE] Set Counters',
	props<{
		fileImportCounters: IQuickFilterCounters | null;
	}>()
);

export const setPaginatedFilesData = createAction(
	'[IMPORTED FILES TABLE] Set Paginated Files Data',
	props<{ filesWithPaginatedData: IFilesWithPaginationData }>()
);

export const loadImportedFilesTableData = createAction(
	'[IMPORTED FILES TABLE] Load Imported Files'
);

export const setTableInitializingStatus = createAction(
	'[IMPORTED FILES TABLE] Set Table Initializing Status',
	props<{ isInitializing: boolean }>()
);

export const handleLoadedFilesTableData = createAction(
	'[IMPORTED FILES TABLE] Handle Loaded Files Table Data',
	props<{ filesWithPaginatedData: IFilesWithPaginationData }>()
);

export const loadTableConfig = createAction('[IMPORTED FILES TABLE] Load Table Config');

export const setFilesTableConfig = createAction(
	'[IMPORTED FILES TABLE] Set Files Table Config',
	props<{ tableConfig: ICMMSTableConfig }>()
);

export const loadSessionInfo = createAction(
	'[IMPORTED FILES TABLE] Load Session Info',
	props<{ sessionId: string }>()
);

export const setQueryPaginationOptions = createAction(
	'[IMPORTED FILES TABLE] Set Query Pagination Params',
	props<{ paginationData: IAuPaginationData }>()
);

export const setFilterOptions = createAction(
	'[IMPORTED FILES TABLE] Set Filter Options',
	props<{ filterOptions: ICmmsFilesFilterVariables }>()
);

export const refreshAllFilePks = createAction(
	'[IMPORTED FILES TABLE] Refresh All File Pks'
);

export const getAllFilePks = createAction(
	'[FILES-IMPORT] Get All FilePks',
	props<{ importSessionPk: string; filter: IQuickFilterSelected }>()
);

export const setAllFilePks = createAction(
	'[FILES-IMPORT] Set All FilePks',
	props<{ filePks: string[] }>()
);
